export default __webpack_public_path__ + "static/media/edit-icon.6b974f0d.svg";